import { atomWithReset } from 'jotai/utils';

import { CommonFields } from '../../data/types';

export const netSuiteCommonFieldValuesState = atomWithReset<CommonFields>({
    department: null,
    class: null,
    location: null,
    subsidiary: null,
});
